async function migrarCalendarioFabrica(){
  const chave='calendario-jornada-liquida-v1',cfg=DB.getObj('config',{}),aplicadas=cfg.migracoesAplicadas||{};
  if(aplicadas[chave])return false;
  const atual=JSON.parse(JSON.stringify(cfg.calendario||{})),normalizado=calendarioNormalizado(atual),mudou=JSON.stringify(atual)!==JSON.stringify(normalizado);
  if(mudou)cfg.calendario=normalizado;
  cfg.migracoesAplicadas={...aplicadas,[chave]:new Date().toISOString()};
  await DB.setObj('config',cfg);
  const jaAuditado=(CACHE.auditoria||[]).some(a=>a.modulo==='calendario'&&a.descricao==='Migrou calendário para jornada líquida de 8 h com almoço de 1h30');
  if(mudou&&!jaAuditado)await auditar('editar','calendario','Migrou calendário para jornada líquida de 8 h com almoço de 1h30',atual,normalizado);
  _calTemp=null;return mudou;
}

async function executarMigracoesIniciais(){
  if(window.MARMORARIA_SAAS_MODE===true&&!window.MarmoriaSaaS?.can('admin'))return false;
  await garantirCatalogoBasePedras();
  if(typeof migrarCalendarioFabrica==='function')await migrarCalendarioFabrica();
  return true;
}

